/*!
 * Copyright 2018, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// override for auto complete search
(function (a) {
	if (a.jqx._jqxComboBox.prototype._defaultSearch === void 0) {
		a.jqx._jqxComboBox.prototype._defaultSearch = a.jqx._jqxComboBox.prototype._search;
		a.jqx._jqxComboBox.prototype._search = function (m) {
			var d = this;
			if (!d.remoteAutoComplete) {
				a.jqx._jqxComboBox.prototype._defaultSearch.call(this, m);
				return;
			}

			if (m.keyCode == 9) return;
			if (d.searchMode == "none" || d.searchMode == null || d.searchMode == "undefined") return;
			if (m.keyCode == 16 || m.keyCode == 17 || m.keyCode == 20) return;
			if (d.checkboxes) return;

			if (!d.isanimating) {
				if (m.altKey && m.keyCode == 38) {
					d.hideListBox("altKey");
					return false;
				}
				if (m.altKey && m.keyCode == 40) {
					if (!d.isOpened()) d.showListBox("altKey");
					return false;
				}
			}
			if (m.keyCode == 37 || m.keyCode == 39) return false;
			if (m.altKey || m.keyCode == 18) return;
			if (m.keyCode >= 33 && m.keyCode <= 40) return;
			if (m.ctrlKey || d.ctrlKey) {
				if (m.keyCode != 88 && m.keyCode != 86) return;
			}

			var l = d.input.val() || '%';

			var s = this;
			var p = function () { s.listBox.vScrollInstance.value = 0; };
			if (l.length >= s.minLength) {
				if (!m.ctrlKey && !m.altKey) {
					if (s.searchString != l) {
						var k = s.listBoxContainer.jqxListBox("source");
						if (k == null) s.listBoxContainer.jqxListBox({ source: s.source });
						if (d._searchTimer) clearTimeout(d._searchTimer);
						if (m.keyCode != 13 && m.keyCode != 27) {
							d._searchTimer = setTimeout(function () {
								p();
								if (s.autoDropDownHeight) s.listBox.autoHeight = true;
								s.searchString = s.input.val() || l;
								if (s.search != null) s.search(s.searchString);
								else throw "'search' function is not defined";
							}, d.remoteAutoCompleteDelay);
						}
					}
					s.searchString = l;
				}
			} else {
				if (d._searchTimer) clearTimeout(d._searchTimer);
				p();
				s.searchString = "";
				s.listBoxContainer.jqxListBox({ source: null });
			}
		}
	}
})(jqxBaseFramework);